import React from 'react'
import Box from'./Box';
//import image2 from '../images/Image1.jpg';
import image2 from '../images/Image1.jpg';
import image3 from '../images/Image3.jpg';
import image4 from '../images/Image4.png';
//https://unsplash.it/350/140/
//blog-channel.com domain name
export default () =>{
    return (
    
        <section className="bg-light page-section" id="portfolio">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase">Image of Game </h2>
              <h3 className="section-subheading text-muted">Dragon ball Legend and fighters </h3>
            
         
<div className='b-container'>
<Box image ={image2} alte='image2' button="DB xenoverse 2" />
<Box image ={image3} alte='image2' button="DB Fighterz"/>
<Box image ={image4} alte='image2' button="DB Legends"/>
    </div>


 </div>
        </div>
            </div>
                       
       
     
      </section>
    )
}